import { GridFooter, GridFooterContainer } from "@mui/x-data-grid";

export function StockTransferCaption({ totalRows, totalQuantity }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Pallet Transferred: {totalRows}</span>
        <span style={{ marginLeft: "1rem" }}>Total Quantity Transfered: {totalQuantity}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}

export function StockAttributesCaption({ totalRows }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Rows: {totalRows}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}

export function StockHoldCaption({ totalRows, totalHold }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Rows: {totalRows}</span>
        <span style={{ marginLeft: "1rem" }}>Total Hold Quantity: {totalHold}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}

export function StockUnHoldCaption({ totalRows, totalHold, totalRemain, totalUnhold }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Rows: {totalRows}</span>
        <span style={{ marginLeft: "1rem" }}>Total Hold: {totalHold}</span>
        <span style={{ marginLeft: "1rem" }}>Total UnHold Quantity: {totalUnhold}</span>
        <span style={{ marginLeft: "1rem" }}>Total Hold Remain: {totalRemain}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}

export function AdjustmentCaption({ totalRows, totalAdjust }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Rows: {totalRows}</span>
        <span style={{ marginLeft: "1rem" }}>Total Adjust Quantity: {totalAdjust}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}

export function DivisionTransferCaption({ totalRows, totalQuantity }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Transfer Rows: {totalRows}</span>
        <span style={{ marginLeft: "1rem" }}>Total Quantity Transfered: {totalQuantity}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}

export function DivisionAdjustmentCaption({ totalRows, totalQuantity }) {
  return (
    <GridFooterContainer>
      <div>
        <span style={{ marginLeft: "1rem" }}>Total Adjustment Rows: {totalRows}</span>
        <span style={{ marginLeft: "1rem" }}>Total Quantity Adjusted: {totalQuantity}</span>
      </div>
      <GridFooter
          sx={{
            border: "none",
          }}
        />
    </GridFooterContainer>
  );
}